import React from 'react';
import { Marker, MarkerProps, Popup, PopupProps } from 'react-leaflet';
import L from 'leaflet';
import { renderToStaticMarkup } from 'react-dom/server';

export interface LeafletRotatableTriangleMarkerProps extends Omit<MarkerProps, 'icon'> {
  rotation: number;
  size?: number;
  color?: string;
  popupProps?: PopupProps;
}

const RotatableTriangleMarker: React.FC<LeafletRotatableTriangleMarkerProps> = ({
  rotation,
  size = 24,
  color = '#3388ff',
  popupProps,
  ...rest
}: LeafletRotatableTriangleMarkerProps) => {
  const points = `${size / 2},0 ${size},${size * 0.8} ${size / 2},${size} 0,${size * 0.8}`;

  const iconSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        transformOrigin: 'center center',
        transform: `rotate(${rotation}deg)`,
      }}
    >
      <polygon points={points} fill={color} stroke="#FFFFFF" strokeWidth={1} />
    </svg>
  );

  const iconHtml = renderToStaticMarkup(iconSvg);

  const customIcon = new L.DivIcon({
    html: iconHtml,
    className: 'leaflet-custom-icon',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });

  return (
    <Marker icon={customIcon} {...rest}>
      {popupProps && <Popup {...popupProps} />}
    </Marker>
  );
};

export default RotatableTriangleMarker;
